export default "__VITE_ASSET__e3de2749__"